import { router } from '~/app/router'

import { last } from 'lodash-es'

export
const { components: { Mainheader: MainHeader } } = last(router.getMatchedComponents({ name: 'menu' }))
